import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';

// Services
import { TrialService } from '../../../core/services/trial/trial.service';
import { CommonService } from '../../../core/services/common/common.service';

// Types
import { TOREPRODUCE } from '../../types/toReproduce';

@Component({
  selector: 'list-element',
  templateUrl: './list-element.component.html',
  styleUrls: ['./list-element.component.scss'],
  standalone: false,
})
export class ListElementComponent {
  @Input() item: TOREPRODUCE;
  @Input() ISBYPRODUCERS?: boolean = false;

  private readonly common = inject(CommonService);
  private readonly router = inject(Router);
  private readonly trial = inject(TrialService);

  get canPlay(): boolean {
    if (this.trial.isTrialMode) {
      return this.item.ISUSABLEINTRIAL as boolean;
    } else {
      return true;
    }
  }

  get itemLabel(): string {
    return this.item.LABELSINLANGUAGE[this.common.currentLang] as string;
  }

  playVideo(ID: number): void {
    if (this.ISBYPRODUCERS) {
      void this.router.navigateByUrl('/choose-byproducer/' + ID.toString());
    } else {
      void this.router.navigateByUrl('/play/' + ID.toString());
    }
  }
}
